import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import config from '../../config'
import Button from '../Button/Button'
import TextField from '../TextField/TextField'
import { useI18nSelector, useI18nState } from '../../v3/context/i18n'
import './Login.scss'
import { doRequest } from '../../middleware'
import { AuthActionTypes } from '../../actions/auth'
import { datadogLogs } from '@datadog/browser-logs'
import { AxiosError } from 'axios'
import { getLoginError, LoginError, LoginErrorMessage } from './LoginError'
import { LoginHelpButton } from './RootLogin'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState<LoginError | null>(null)
  const [sent, setSent] = useState(false)
  const history = useHistory()
  const i18n = useI18nSelector()
  const { locale } = useI18nState()

  const handleInputChange = (value: string) => {
    setEmail(value)
    setError(null)
  }

  const handleSubmit = () => {
    datadogLogs.setUser({ id: email })

    doRequest({
      url: `${config.api}/credentials/forgot`,
      method: 'POST',
      payload: {
        email,
      },
      headers: {
        'Accept-Language': locale,
      },
      validateStatus: (status) => {
        return status === 200
      },
      type: AuthActionTypes.Forgot,
    })
      .then((res) => {
        setError(null)
        setSent(true)
      })
      .catch((err: AxiosError) => {
        setError(getLoginError(i18n, err, AuthActionTypes.Forgot))
      })
  }

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      handleSubmit()
    }
  }

  const renderMessage = () => {
    let message = i18n('auth.forgot.introduction')
    let className = 'message'

    if (sent) {
      message = i18n('auth.help.resetLinkSent')
      className = 'attention'
    }

    return <p className={className}>{message}</p>
  }

  return (
    <div className="LoginScreen forgot-screen">
      <div className="Login">
        <div className="form">
          <div className="logo" />
          {renderMessage()}
          <LoginErrorMessage error={error} />
          {sent ? null : (
            <TextField
              className={'forgot-password-input'}
              error={error?.inputs?.email}
              label={i18n('auth.emailLabel')}
              onInput={handleInputChange}
              onKeyDown={handleKeyDown}
              type="email"
            />
          )}
          <div className="buttons">
            <div className="actions forgot">
              <Button
                className="cancel"
                onClick={() => history.push('/login')}
                variant="contained"
                color={sent ? 'primary' : 'default'}
                disableElevation
              >
                {sent ? i18n('auth.cta.goBack') : i18n('global.action.labels.cancel')}
              </Button>
              {sent ? null : (
                <Button className="submit" variant="contained" color="primary" disableElevation onClick={handleSubmit}>
                  {i18n('auth.cta.sendEmail')}
                </Button>
              )}
            </div>
            <div className="helpers">
              <LoginHelpButton reqType={AuthActionTypes.Login} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
